export function addCurrent(calledtimeentries) {
    return {
        type: 'ADD_CURRENT',
        calledtimeentries,
    }
}
